// Tag/fingerprint/header constants used to identify Sentry events sent by the
// smoke test, kept in their own file (no dependencies) so they can be safely
// imported by both `api/connectApi.js` (which reports real HTTP errors) and
// `helpers/sentrySmokeTest.ts` (which triggers them) without creating a
// circular import between the two.
export const SENTRY_SMOKE_TEST_TAG = 'connect_smoke_test'
export const SENTRY_SMOKE_TEST_FINGERPRINT = 'connect-sentry-smoke-test'

// Header used to mark requests sent by the smoke test so connectApi's
// interceptor can tag/fingerprint the resulting Sentry event as a smoke test
// event, even though it's going through the real error-reporting code path.
export const SMOKE_TEST_HEADER = 'X-Connect-Smoke-Test'
